<template>
  <motlet :options="motletOptions">
    <template #content>
      <!-- eslint-disable-next-line prettier/prettier -->
      <bar-horizontal-stack
        :system="system"
        :items="nodes"
        :values="values"
        :contextmenu="onContextmenuChart"
      />
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { cloneDeep } from 'lodash';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import BarHorizontalStack from '../chart/BarHorizontalStack.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    BarHorizontalStack,
  },
  data() {
    return {
      motletOptions: {
        id: 'erview/system/java/Transaction',
        title: 'Transaction',
      },
      messageName: 'rawJavaTrxn',
      messageFields: [
        {
          field: 'openTransCount',
          code: 1,
          name: 'Transaction Count',
        },
      ],
      messageSequence: 0,
      values: [],
      recieve: {},
      contextmenuUrl: '/views/detailview/java/db',
    };
  },
  watch: {
    nodes: {
      handler: 'changeNodesHandler',
    },
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
        every(key, last.data, last.ctime, last.empty);
      });
    },
    wsDataHandler(key, response) {
      ++this.messageSequence;
      // 인스턴스 마다 값을 누적한다.
      this.recieve[key.nodeId] = [];
      response.forEach(res => {
        this.messageFields.forEach(f => {
          if (!this.recieve[key.nodeId].find(v => v.code == f.code)) this.recieve[key.nodeId].push({ value: 0, code: f.code, name: f.name });
          this.recieve[key.nodeId].find(v => v.code == f.code).value = res[f.field] || 0;
        });
      });

      // 시스템에 속한 인스턴스들의 값이 모두 취합 된 후
      if (this.messageSequence == this.nodes.length) {
        this.messageSequence = 0;
        const recieve = cloneDeep(this.recieve);
        // 취합된 값의 종류별 값을 모두 발췌한다.
        const codes = Object.keys(recieve).reduce((acc, id) => {
          recieve[id].forEach(value => (acc[value.code] = value.name));
          return acc;
        }, {});
        // 모든 종류별 값을 포함하고 있는 상태로 재구성한다.
        this.values = this.nodes.map(item => {
          return Object.keys(codes)
            .sort((a, b) => a - b)
            .map(code => ({
              code,
              name: codes[code],
              value: (recieve[item.id].find(value => value.code == code) || {}).value || 0,
            }));
        });
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.nodes.map(node => ({
          key: { name: this.messageName, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
          fields: this.messageFields.map(f => f.field),
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeNodesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>
